import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import React from 'react'

import LockClosedIcon from '../../icons/lock-closed'
import LockOpenIcon from '../../icons/lock-open'
import RoundedIcon from './rounded-icon'

type Props = {
  isLocked: boolean
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  size?: number
  loading?: boolean
  className?: string
}

/**
 * Shared lock pictogram: closed + green when locked, open + orange when unlocked.
 * Pass `onClick` to make it interactive (lock/unlock); omit it for a display-only status.
 */
const Lock: React.FC<Props> = ({ isLocked, onClick, size = 24, loading = false, className }) => {
  return (
    <RoundedIcon
      icon={isLocked ? LockClosedIcon : LockOpenIcon}
      color={isLocked ? tailwindColors.green.DEFAULT : tailwindColors.orange.DEFAULT}
      backgroundColor={
        isLocked ? tailwindColors.green.light.DEFAULT : tailwindColors.orange.light.DEFAULT
      }
      size={size}
      onClick={loading ? undefined : onClick}
      className={cn(
        'rounded-full',
        onClick && !loading && 'cursor-pointer',
        loading && 'pointer-events-none opacity-50',
        className
      )}
    />
  )
}

export default Lock
